import React, { useEffect, useState } from 'react';

import { message, Spin } from 'antd';
import { useSelector } from 'react-redux';
import { TTUserProfile } from '../../interfaces/user';
import { RootState } from '../../rootReducer';
import { LoadingIcon } from '../components/Spinner';
import { GuestSubscription } from '../../interfaces/subscription';
import { useNavigate } from '../../navigation';
import moment from 'moment-timezone';
import axios from 'axios';
import { apiUrl } from '../../env';
import { getAuthHeaders } from '../../api/utils';
import { centsToDollars } from '../utils';
import { useAppDispatch } from '../../store';

type Props = {};

export function GuestSubscriptions() {
  const guest = useSelector<RootState, TTUserProfile | null>(
    state => state.auth.userProfile,
  );
  const [fetching, setFetching] = useState(false);
  const [subscriptions, setSubscriptions] = useState<GuestSubscription[]>([]);
  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const navgiate = useNavigate();
  const dispatch = useAppDispatch();

  const fetchSubs = async () => {
    try {
      setFetching(true);
      const response = await axios.get<GuestSubscription[]>(
        `${apiUrl}/api/v1/subscriptions/?guest_id=${guest?.id}`,
        {
          headers: await getAuthHeaders(),
        },
      );
      setSubscriptions(response.data);
      setFetching(false);
    } catch (e) {
      console.log(e?.repsonse?.data);
      message.error(
        e?.response?.data?.detail[0]?.msg ??
          e?.response?.data?.detail ??
          'Unable to fetch your subscriptions.',
      );
      setFetching(true);
    }
  };

  useEffect(() => {
    if (guest) {
      fetchSubs();
    }
  }, [guest?.id]);
  if (!guest) {
    return <></>;
  }
  return (
    <div className="mt-8 flex flex-col">
      <div className="overflow-x-auto ">
        <div className="inline-block min-w-full py-2 align-middle ">
          <div className="overflow-hidden ">
            <div className="sm:flex-auto mb-4">
              <h3 className="text-lg font-semibold text-on-surface">
                Subscriptions
              </h3>
            </div>
            <Spin spinning={fetching} indicator={LoadingIcon}>
              <div className="min-w-full ">
                <div className="flex flex-col space-y-2 ">
                  {subscriptions?.map(sub => (
                    <div
                      key={sub?.id?.toString()}
                      className="rounded-md bg-primary/10 border border-outline px-2 py-2"
                      onClick={() => {
                        //   navgiate(`subscriptions/${sub}`);
                      }}
                    >
                      <div className="flex justify-between items-center">
                        <div className="flex flex-col">
                          <label className="text-xs font-semibold text-on-surface">
                            Subscriptions Id
                          </label>
                          <td className="whitespace-nowrap  text-sm font-medium text-on-surface ">
                            {sub.subscription_id}
                          </td>
                        </div>
                        <div className="flex flex-col">
                          <label className="text-xs font-semibold text-on-surface text-right">
                            Order Date
                          </label>

                          <td className="whitespace-nowrap  text-sm   text-on-surface text-right">
                            {moment.utc(sub?.created_at).tz(tz).format('lll')}
                          </td>
                        </div>
                      </div>
                      <div className="flex flex-row items-center justify-between">
                        <div>
                          {sub.is_custom_amount ? (
                            <div>
                              <p className="text-on-primary-container text-md ">
                                {centsToDollars(sub.price_data['unit_amount'])}{' '}
                                every{' '}
                                {sub.price_data['recurring']['interval_count']}{' '}
                                {sub.price_data['recurring']['interval']}
                                {sub.price_data['recurring']['interval_count'] >
                                1
                                  ? 's'
                                  : ''}
                              </p>
                            </div>
                          ) : (
                            <>
                              {sub.price_ids?.map(p => {
                                <></>;
                              })}
                            </>
                          )}
                        </div>
                        <td className="whitespace-nowrap text-sm text-on-surface pt-2 text-right">
                          <div>
                            {sub.status === 'trialing' ? (
                              <div>
                                <div className="text-md text-on-primary-container">
                                  Subscription Status:{' '}
                                  <span className="font-semibold text-primary">
                                    Trialing
                                  </span>
                                </div>
                                <div className="text-md text-on-primary-container">
                                  Trial ends:{' '}
                                  <span className="font-semibold">
                                    {moment
                                      .unix(sub.trial_end_at)
                                      ?.format('lll')}
                                  </span>
                                </div>
                              </div>
                            ) : sub.status === 'canceled' ? (
                              <div>
                                <div className="text-md text-on-primary-container">
                                  Subscription Status:{' '}
                                  <span className="font-semibold text-primary">
                                    Canceled
                                  </span>
                                </div>
                                <div className="text-md text-on-primary-container">
                                  Canceled at:{' '}
                                  <span className="font-semibold">
                                    {moment.unix(sub.cancel_at)?.format('lll')}
                                  </span>
                                </div>
                              </div>
                            ) : (
                              <></>
                            )}
                          </div>
                        </td>
                      </div>
                      {sub.status !== 'canceled' && sub.cancel_at ? (
                        <div className="bg-tertiary-container text-on-tertiary-container rounded-md py-2 px-2 text-center mt-2">
                          Subscription will be canceled before the next billing
                          period at{' '}
                          <span className="font-semibold">
                            {moment.unix(sub.cancel_at)?.format('lll')}
                          </span>
                        </div>
                      ) : (
                        <></>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </Spin>
          </div>
        </div>
      </div>
    </div>
  );
}
